import { parse as faParse } from '@fortawesome/fontawesome-svg-core'

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.

// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
    obj = obj - 0

    // eslint-disable-next-line no-self-compare
    return obj === obj
}

export function camelize(string) {
    if (_isNumerical(string)) {
        return string
    }

    // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : ''
    })

    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1)
}

// Get CSS class list from a props object
export function classList(props) {
    const {
        spin,
        pulse,
        fixedWidth,
        inverse,
        border,
        listItem,
        flip,
        size,
        rotation,
        pull
    } = props

    // map of CSS class names to properties
    const classes = {
        'fa-spin': spin,
        'fa-pulse': pulse,
        'fa-fw': fixedWidth,
        'fa-inverse': inverse,
        'fa-border': border,
        'fa-li': listItem,
        'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
        'fa-flip-vertical': flip === 'vertical' || flip === 'both',
        [`fa-${size}`]: typeof size !== 'undefined' && size !== null,
        [`fa-rotate-${rotation}`]:
        typeof rotation !== 'undefined' && rotation !== null && rotation !== 0,
        [`fa-pull-${pull}`]: typeof pull !== 'undefined' && pull !== null,
        'fa-swap-opacity': props.swapOpacity
    }

    // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes)
        .map(key => (classes[key] ? key : null))
        .filter(key => key)
}

export function styleList (props) {
    let styles = {
        '--fa-primary-color': props.primaryColor,
        '--fa-secondary-color': props.secondaryColor,
        '--fa-primary-opacity': props.primaryOpacity,
        '--fa-secondary-opacity': props.secondaryOpacity
    }

    Object.keys(styles).forEach((key) => !styles[key] && delete styles[key]);

    return styles;
}


// Normalize icon arguments
export function normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && typeof icon === 'object' && icon.prefix && icon.iconName && icon.icon) {
        return icon
    }

    if (faParse.icon) {
        return faParse.icon(icon)
    }

    // if the icon is null, there's nothing to do
    if (icon === null) {
        return null
    }

    // if the icon is an object and has a prefix and an icon name, return it
    if (icon && typeof icon === 'object' && icon.prefix && icon.iconName) {
        return icon
    }

    // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) {
        // use the first item as prefix, second as icon name
        return { prefix: icon[0], iconName: icon[1] }
    }

    // if it's a string, use it as the icon name
    if (typeof icon === 'string') {
        return { prefix: 'fas', iconName: icon }
    }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
export function objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return (Array.isArray(value) && value.length > 0) ||
    (!Array.isArray(value) && value)
        ? { [key]: value }
        : {}
}
